import { createSelector } from '@ngrx/store';
import { selectNotificationsState } from '../reducers';
import { Notifications, NotificationsDTO } from '../../commons/models/notifications';
import { NotificationState } from '../reducers/notifications.reducers';

export const getNotificationsTableState = createSelector(
    selectNotificationsState,
  (state: NotificationState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getNotifications = createSelector(
    selectNotificationsState,
  (state: NotificationState) => state.list
);

export const getTotalNotifications = createSelector(
    getNotificationsTableState,
  (tableState) => tableState.total
);

export const getNotificationsCurrentPage = createSelector(
    getNotificationsTableState,
  (tableState) => tableState.currentPage
);

export const getNotificationsPerPage = createSelector(
    getNotificationsTableState,
  (tableState) => tableState.perPage
);

export const getNotificationsDirection = createSelector(
    getNotificationsTableState,
    (tableState) => tableState.direction
);

export const getFilters = createSelector(
    getNotificationsTableState,
  (tableState) => tableState.filters
);

export const getNotificationDialogId = createSelector(
    selectNotificationsState,
  (state: NotificationState) => state.dialogId
);

export const getSelectionDialogId = createSelector(
    selectNotificationsState,
  (state: NotificationState) => state.selectionDialogId
);

export const getSelectedNotificationsCurrentPage = createSelector(
    selectNotificationsState,
  (state: NotificationState) => {
    const selection = (state.selectedNotifications || []).map(bl => bl.id);
    return state.list?.filter(bl => selection.includes(bl.id));
  }
);